// extracted by mini-css-extract-plugin
module.exports = {"f_container":"Follow_f_container__2ZoAU","social_links":"Follow_social_links__KJr3H","app_header":"Follow_app_header__2f87q","app_img":"Follow_app_img__3Sxhh"};